import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/blast-off.png'


const _hoisted_1 = { class: "blast-off-area pb-100" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = {
  class: "col-lg-6 col-md-6",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "100"
}
const _hoisted_5 = { class: "blast-off-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "blast-off-bg bg-img",
        style: _normalizeStyle({ backgroundImage: `url(${_ctx.bgImage})` })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[1] || (_cache[1] = _createElementVNode("h2", null, "انطلق في عالم الترفيه", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("p", null, " مع خوادم فائقة السرعة ومقاومة للحظر، شاهد، استمتع، وتابع مبارياتك المفضلة بجودة 4K حقيقية وبدون أدنى تقطيع. ", -1)),
              _createVNode(_component_RouterLink, {
                to: "/pricing-plan",
                class: "btn bg-golden text-black"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("span", { class: "border-style" }, "اشترك الآن", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("div", {
            class: "col-lg-6 col-md-6",
            "data-aos": "fade-up",
            "data-aos-duration": "1000",
            "data-aos-delay": "100"
          }, [
            _createElementVNode("div", { class: "blast-off-img" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "IPTV Entertainment"
              })
            ])
          ], -1))
        ])
      ], 4)
    ])
  ]))
}